"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRegistrableProgrammaticAdvertiserDomain = exports.normalizeProgrammaticAdvertiserDomain = void 0;
const tldts_1 = require("tldts");
const INVALID_DOMAIN_CHARACTERS = /[\s/@:?#[\]]/;
const normalizeProgrammaticAdvertiserDomain = (value) => {
    if (typeof value !== "string")
        return value;
    const candidate = value.trim().toLowerCase();
    if (!candidate || INVALID_DOMAIN_CHARACTERS.test(candidate))
        return candidate;
    return (0, tldts_1.getDomain)(candidate, { allowPrivateDomains: false })?.toLowerCase() ?? candidate;
};
exports.normalizeProgrammaticAdvertiserDomain = normalizeProgrammaticAdvertiserDomain;
const isRegistrableProgrammaticAdvertiserDomain = (value) => {
    if (typeof value !== "string" || !value || INVALID_DOMAIN_CHARACTERS.test(value))
        return false;
    return (0, tldts_1.getDomain)(value, { allowPrivateDomains: false })?.toLowerCase() === value.toLowerCase();
};
exports.isRegistrableProgrammaticAdvertiserDomain = isRegistrableProgrammaticAdvertiserDomain;
